import { userImage } from 'src/utils/images';

import { useSelector } from 'src/redux/store';
import { selectCurrentUser } from 'src/redux/slices/auth';

//
import CustomAvatar from './CustomAvatar';
import { CustomAvatarProps } from './types';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }: CustomAvatarProps) {
  const user = useSelector(selectCurrentUser) || {};

  const { displayName = '', avatarUrl = '' } = user;

  return (
    <CustomAvatar src={userImage(avatarUrl)} alt={displayName} name={displayName} {...other}>
      {displayName}
    </CustomAvatar>
  );
}
